import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { Company } from "@/types/company";
import { SavedCompany } from "@/types/user";

export interface ToggleFollowCompanyData {
  company_id: Company["id"];
}

export interface ToggleFollowCompanyResponse {
  success: boolean;
  message: string;
  saved_company: SavedCompany;
}

export const useToggleFollowCompany = () => {
  const [data, setData] = useState<ToggleFollowCompanyResponse | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const toggleFollowCompany = async (formData: ToggleFollowCompanyData) => {
    setLoading(true);
    setError(null);

    const authToken = localStorage.getItem("authToken");
    if (!authToken) {
      setError("Not authenticated.");
      setLoading(false);
      return;
    }

    try {
      const response = await axiosInstance.post<ToggleFollowCompanyResponse>(
        "users/users/toggle_follow_company/",
        formData,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      setData(response.data);
      return response.data;
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, toggleFollowCompany };
};
